<script lang="ts">
	interface Props {
		children?: import("svelte").Snippet;
	}

	let { children }: Props = $props();
</script>

<span class="bg-isbre dark:bg-grey-20">{@render children?.()}</span>
